import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import OwtSvc from "@/services/OutpatientWaitingService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "outpatient-waiting"
})
class OutpatientWaitingModule extends VuexModule {
  sessions: any[] = [];
  currentSession: any = null;
  poliklinikList: any[] = [];
  dashboard: any = null;
  rekapHarian: any[] = [];
  monthlyReport: any = null;
  monthlySessions: any[] = [];
  loading = false;
  pagination: any = null;

  @Mutation SET_SESSIONS(val: any[]) {
    this.sessions = val;
  }

  @Mutation SET_CURRENT_SESSION(val: any) {
    this.currentSession = val;
  }

  @Mutation SET_POLIKLINIK_LIST(val: any[]) {
    this.poliklinikList = val;
  }

  @Mutation SET_DASHBOARD(val: any) {
    this.dashboard = val;
  }

  @Mutation SET_REKAP_HARIAN(val: any[]) {
    this.rekapHarian = val;
  }

  @Mutation SET_MONTHLY_REPORT(val: any) {
    this.monthlyReport = val;
  }

  @Mutation SET_MONTHLY_SESSIONS(val: any[]) {
    this.monthlySessions = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_PAGINATION(val: any) {
    this.pagination = val;
  }

  @Action async loadPoliklinik() {
    try {
      const dt = await OwtSvc.getPoliklinik();
      this.SET_POLIKLINIK_LIST(dt.data?.data || []);
    } catch {
      this.SET_POLIKLINIK_LIST([]);
    }
  }

  @Action async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await OwtSvc.getList(params);
      const resp = dt.data;
      this.SET_SESSIONS(resp.data?.data || []);
      this.SET_PAGINATION({
        current_page: resp.data?.current_page,
        last_page: resp.data?.last_page,
        total: resp.data?.total,
        per_page: resp.data?.per_page,
      });
    } catch {
      this.SET_SESSIONS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDetail(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await OwtSvc.find(id);
      this.SET_CURRENT_SESSION(dt.data?.data || null);
    } catch {
      this.SET_CURRENT_SESSION(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDashboard(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await OwtSvc.getDashboard(params);
      this.SET_DASHBOARD(dt.data?.data || null);
    } catch {
      this.SET_DASHBOARD(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadRekapHarian(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await OwtSvc.getRekapHarian(params);
      this.SET_REKAP_HARIAN(dt.data?.data || []);
    } catch {
      this.SET_REKAP_HARIAN([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMonthly({ tahun, bulan }: { tahun: number; bulan: number }) {
    this.SET_LOADING(true);
    try {
      const dt = await OwtSvc.getMonthly(tahun, bulan);
      this.SET_MONTHLY_REPORT(dt.data?.data?.report || null);
      this.SET_MONTHLY_SESSIONS(dt.data?.data?.sessions || []);
    } catch {
      this.SET_MONTHLY_REPORT(null);
      this.SET_MONTHLY_SESSIONS([]);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_SESSIONS([]);
    this.SET_CURRENT_SESSION(null);
    this.SET_DASHBOARD(null);
    this.SET_REKAP_HARIAN([]);
    this.SET_MONTHLY_REPORT(null);
    this.SET_MONTHLY_SESSIONS([]);
  }
}

export const storeOutpatientWaiting = getModule(OutpatientWaitingModule);
